const helpBubble: HTMLElement | null = document.querySelector('.help-bubble');

document.addEventListener("DOMContentLoaded", () => {
  
  // remove link for "Bonus" breadcrumb
  const bonusBreadcrumb: HTMLAnchorElement | null = document.querySelector(".breadcrumb a[href='/toolkit/bonus/']");
  if (bonusBreadcrumb !== null) {
    bonusBreadcrumb.href = '#';
  }

  // display playlist tooltip
  if (helpBubble) helpBubble.hidden = false;
 
}, {once: true});


// close tooltip
const tooltipCloseBtn: HTMLAnchorElement | null = document.querySelector('.help-bubble a.close');
tooltipCloseBtn?.addEventListener("click", (e) => {
  e.preventDefault();
  if (helpBubble) helpBubble.hidden = true;
}, {once: true});


// show bounce when enters viewport
const playlistContainer: HTMLElement | null = document.querySelector("section.section--video div.container");

window.addEventListener("scroll", () => {

  const rect = playlistContainer?.getBoundingClientRect();
  if (
    rect && window.innerHeight - rect.y > 100 && 
    rect.y > 10
    && helpBubble
  ) {
    helpBubble.classList.add("bounce2");
  } else if (helpBubble) {
    helpBubble.classList.remove("bounce2");
  }

});


